import React from "react";
import { Grid, Segment } from "semantic-ui-react";

const assetsIds = ["136692", "169898", "162431", "141215", "141190"];

const UnityAssets = () => (
  <Segment inverted>
    <Grid inverted verticalAlign="middle">
      <Grid.Row centered>
        <div style={{ height: "20px" }} />
      </Grid.Row>
      {assetsIds.map((id) => (
        <Grid.Row centered>
          <iframe
            src={`https://assetstore.unity.com/linkmaker/embed/package/${id}/widget-wide?aid=1101l4LJP`}
            style={{
              width: "600px",
              height: "130px",
              border: "0px",
              padding: "unset",
            }}
          />
        </Grid.Row>
      ))}
    </Grid>
  </Segment>
);

export default UnityAssets;
